import Skeleton from '@mui/material/Skeleton';
import styles from './SkeletonCourseDetailsView.module.scss';
import globalStyles from '../../../../styles/exported.module.scss';
import { classes } from '../../../../lib/utils/cssUtils';
import { courseDetailsIds } from '../../../../lib/tests/testIds';

const SkeletonCourseDetailsSection = () => {
  return (
    <div>
      <Skeleton variant="rectangular" className={styles.line1} />
      <Skeleton variant="rectangular" className={styles.line2} />
      <Skeleton variant="rectangular" className={styles.line3} />
    </div>
  );
};

const SkeletonCourseDetailsView = () => {
  return (
    <div className={globalStyles.fullTabsWidth} data-testid={courseDetailsIds.skeletonCourseDetailsContainer}>
      <div className={styles.sectionWrapper}>
        <div className={styles.sectionGrid}>
          <div className={styles.leftSubsection}>
            <Skeleton variant="rectangular" className={styles.title} />
          </div>
          <div className={styles.rightSubsection}>
            <Skeleton variant="rectangular" className={classes(styles.rightSubsection, styles.title)} />
          </div>
        </div>
      </div>
      <div className={styles.grayBackground}>
        <div className={styles.sectionWrapper}>
          <div className={styles.sectionGrid}>
            <div className={styles.leftSubsection}>
              <Skeleton variant="rectangular" className={styles.title} />
            </div>
            <div className={styles.rightSubsection}>
              <Skeleton variant="rectangular" className={classes(styles.rightSubsection, styles.description)} />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.sectionWrapper}>
        <div className={styles.sectionGrid}>
          <div className={styles.leftSubsection}>
            <Skeleton variant="rectangular" className={styles.secondTitle} />
          </div>
          <div className={styles.rightSubsection}>
            <SkeletonCourseDetailsSection />
            <Skeleton className={styles.divider} />
            <SkeletonCourseDetailsSection />
          </div>
        </div>
      </div>
      <div className={styles.grayBackground}>
        <div className={styles.sectionWrapper}>
          <div className={styles.sectionGrid}>
            <div className={styles.leftSubsection}>
              <Skeleton variant="rectangular" className={styles.secondTitle} />
            </div>
            <div className={styles.rightSubsection}>
              <SkeletonCourseDetailsSection />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkeletonCourseDetailsView;
